export class MockedVitosetAquaFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter/minute',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.consumption.flow.current',
        gatewayId: gatewaySerial,
        feature: 'water.consumption.flow.current',
        timestamp: '2022-10-07T07:14:44.243Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 231,
            unit: 'liter',
          },
          lastSevenDays: {
            type: 'number',
            value: 204,
            unit: 'liter',
          },
          total: {
            type: 'number',
            value: 54578,
            unit: 'liter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.consumption.summary',
        gatewayId: gatewaySerial,
        feature: 'water.consumption.summary',
        timestamp: '2022-10-07T07:06:39.381Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1',
        timestamp: '2022-10-07T01:35:43.582Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          name: {
            value: 'Wäscheraum',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 40,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.name',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.name',
        timestamp: '2022-10-06T15:53:56.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'dBm',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.rssi',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.rssi',
        timestamp: '2022-10-07T01:35:43.612Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.valves.shutoff.holiday/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.valves.shutoff.holiday/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.valves.shutoff.holiday',
        gatewayId: gatewaySerial,
        feature: 'water.valves.shutoff.holiday',
        timestamp: '2022-10-06T15:53:56.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          state: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.valves.shutoff.motor',
        gatewayId: gatewaySerial,
        feature: 'water.valves.shutoff.motor',
        timestamp: '2022-10-07T01:35:43.630Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'service',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.valves.shutoff.state',
        gatewayId: gatewaySerial,
        feature: 'water.valves.shutoff.state',
        timestamp: '2022-10-07T01:35:43.629Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-10-07T01:35:43.645Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          maxFlow: {
            unit: 'liter/minute',
            value: 25,
            type: 'number',
          },
          maxDuration: {
            unit: 'minute',
            value: 0,
            type: 'number',
          },
        },
        commands: {
          setMaxFlow: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.leakDetection.configuration.flowAlert/commands/setMaxFlow',
            name: 'setMaxFlow',
            isExecutable: true,
            params: {
              maxFlow: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          setMaxDuration: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.leakDetection.configuration.flowAlert/commands/setMaxDuration',
            name: 'setMaxDuration',
            isExecutable: true,
            params: {
              maxDuration: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 65535,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.configuration.flowAlert',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.configuration.flowAlert',
        timestamp: '2022-10-06T15:53:56.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          lowLevelAlertDays: {
            unit: 'days',
            value: 14,
            type: 'number',
          },
        },
        commands: {
          setLowLevelAlertTrigger: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.softener.configuration.lowSaltAlert/commands/setLowLevelAlertTrigger',
            name: 'setLowLevelAlertTrigger',
            isExecutable: true,
            params: {
              days: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0,
                  max: 100,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.softener.configuration.lowSaltAlert',
        gatewayId: gatewaySerial,
        feature: 'water.softener.configuration.lowSaltAlert',
        timestamp: '2022-10-07T01:35:43.631Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 58,
                busType: 'InternalUart',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0041.0503.2228.0014',
                hardwareVersion: '0041.0400.0200.0000',
                etn: '' + gatewaySerial + '',
              },
              {
                busAddress: 95,
                busType: 'InternalUart',
                deviceFunction: 'No',
                softwareVersion: '0079.0500.2237.1060',
                hardwareVersion: '0079.0500.0738.2461',
                etn: '000000000000',
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2022-10-07T01:35:43.652Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'open',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.valves.shutoff.position',
        gatewayId: gatewaySerial,
        feature: 'water.valves.shutoff.position',
        timestamp: '2022-10-07T01:35:43.623Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2022-10-06T00:34:16.085Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2022-10-07T01:35:43.646Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.errors.active',
        gatewayId: gatewaySerial,
        feature: 'device.errors.active',
        timestamp: '2022-10-06T00:34:16.076Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 0,
            unit: '',
          },
          version: {
            type: 'number',
            value: 0,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 0,
            unit: '',
          },
          build: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.version.hardware',
        timestamp: '2022-10-07T01:35:43.617Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 0,
            unit: '',
          },
          version: {
            type: 'number',
            value: 0,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 0,
            unit: '',
          },
          build: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.version.software',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.version.software',
        timestamp: '2022-10-07T01:35:43.607Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '0000000000000000',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.serial',
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2022-10-07T01:35:43.649Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          name: {
            value: 'Heizungskeller',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 40,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.name',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.name',
        timestamp: '2022-10-06T15:53:56.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0',
        timestamp: '2022-10-07T01:35:43.581Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 0,
            unit: '',
          },
          version: {
            type: 'number',
            value: 0,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 0,
            unit: '',
          },
          build: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.version.software',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.version.software',
        timestamp: '2022-10-07T01:35:43.608Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 25.2,
            unit: 'liter/minute',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.consumption.flow.max',
        gatewayId: gatewaySerial,
        feature: 'water.consumption.flow.max',
        timestamp: '2022-10-07T01:35:43.573Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-10-07T01:35:43.636Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: [0, 1],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage',
        timestamp: '2022-10-07T01:35:43.579Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          level: {
            type: 'number',
            value: 100,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.battery',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.battery',
        timestamp: '2022-10-07T01:35:43.588Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          family: {
            type: 'number',
            value: 0,
            unit: '',
          },
          version: {
            type: 'number',
            value: 0,
            unit: '',
          },
          revision: {
            type: 'number',
            value: 0,
            unit: '',
          },
          build: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.version.hardware',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.version.hardware',
        timestamp: '2022-10-07T01:35:43.618Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '00:00:00:00:00:00:00:00',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.id',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.id',
        timestamp: '2022-10-07T01:35:43.592Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'dBm',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.rssi',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.rssi',
        timestamp: '2022-10-07T01:35:43.613Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'OK',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.status',
        gatewayId: gatewaySerial,
        feature: 'device.status',
        timestamp: '2022-10-07T01:35:43.648Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2022-10-06T00:34:16.082Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '0000000000000000',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2022-10-07T01:35:43.651Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '00:00:00:00:00:00:00:00',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.1.id',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.1.id',
        timestamp: '2022-10-07T01:35:43.593Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'VitosetAqua19D',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.variant',
        gatewayId: gatewaySerial,
        feature: 'device.variant',
        timestamp: '2022-10-07T01:35:43.650Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          level: {
            type: 'number',
            value: 100,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.leakDetection.sensors.leakage.0.battery',
        gatewayId: gatewaySerial,
        feature: 'water.leakDetection.sensors.leakage.0.battery',
        timestamp: '2022-10-07T01:35:43.587Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-10-06T00:34:16.079Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2022-10-07T01:35:43.647Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
      {
        properties: {
          remaining: {
            type: 'number',
            value: 21,
            unit: 'days',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/VitosetAqua/features/water.softener.salt.level.days',
        gatewayId: gatewaySerial,
        feature: 'water.softener.salt.level.days',
        timestamp: '2022-10-07T01:35:43.622Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'VitosetAqua',
      },
    ];
  }
}
